import { createStyles } from "@mantine/core";

export const useBreadcrumbStyles = createStyles(() => ({
  breadcrumbLink: {
    color: "#839099",
    textDecoration: "none",
    fontWeight: 400,
    fontSize: 14,
    cursor: "pointer",
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    "&:hover": { textDecoration: "underline", color: "#495057" },
  },
  breadcrumbCurrent: {
    color: "#062133",
    fontWeight: 400,
    fontSize: 14,
    whiteSpace: "normal",
    overflowWrap: "anywhere",
  },
}));
